/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Generated class for the LandingButton component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'landing-button',
  templateUrl: 'landing-button.html'
})
export class LandingButton {

  @Input()
  icon: string;

  @Input()
  title: string;

  @Output()
  buttonClick: EventEmitter<void> = new EventEmitter<null>();

  constructor() {
    console.log('Hello LandingButton Component');
  }

  buttonClicked() {
    this.buttonClick.next();
  }

}



// WEBPACK FOOTER //
// ./src/components/landing-button/landing-button.ts